/* unplugin-vue-components disabled */import { render } from "./virtual-scroller.vue?vue&type=template&id=3fdb924f&scoped=true"
import script from "./virtual-scroller.vue?vue&type=script&lang=js"
export * from "./virtual-scroller.vue?vue&type=script&lang=js"

import "./virtual-scroller.vue?vue&type=style&index=0&id=3fdb924f&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fdb924f"],['__file',"src/components/virtual-scroller/virtual-scroller.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fdb924f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fdb924f', __exports__)) {
    api.reload('3fdb924f', __exports__)
  }
  
  module.hot.accept("./virtual-scroller.vue?vue&type=template&id=3fdb924f&scoped=true", () => {
    api.rerender('3fdb924f', render)
  })

}


export default __exports__